<div class="inventory-container">
  <!-- Header -->
  <div class="inventory-header">
    <h1 class="inventory-title">Add New Category</h1>
    <div class="header-actions">
      <button
        (click)="goBack()"
        class="back-button"
      >
        ← Back to Categories
      </button>
    </div>
  </div>

  <!-- Form Container -->
  <div class="form-container">
    <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()" class="category-form">
      
      <!-- Basic Information Section -->
      <div class="form-section">
        <h3 class="section-title">Basic Information</h3>
        
        <div class="form-row">
          <!-- Parent Category -->
          <div class="form-group">
            <label for="parentId" class="form-label">Parent Category</label>
            <select 
              id="parentId"
              formControlName="parentId"
              class="form-select"
            >
              <option value="0">Main Category (No Parent)</option>
              <option 
                *ngFor="let category of parentCategories" 
                [value]="category.id"
              >
                {{ getCategoryName(category) }}
              </option>
            </select>
            <div class="error-message" *ngIf="showError('parentId')">
              {{ getError('parentId') }}
            </div>
          </div>

          <!-- Level -->
          <div class="form-group">
            <label for="level" class="form-label">Level</label>
            <input
              type="number"
              id="level"
              formControlName="level"
              class="form-input"
              min="0"
              placeholder="Enter category level"
            />
            <div class="error-message" *ngIf="showError('level')">
              {{ getError('level') }}
            </div>
          </div>
        </div>

        <div class="form-row">
          <!-- Code -->
          <div class="form-group">
            <label for="code" class="form-label">Category Code *</label>
            <input
              type="text"
              id="code"
              formControlName="code"
              class="form-input"
              placeholder="Enter unique category code"
            />
            <div class="error-message" *ngIf="showError('code')">
              {{ getError('code') }}
            </div>
          </div>

          <!-- Slug -->
          <div class="form-group">
            <label for="slug" class="form-label">Slug *</label>
            <input
              type="text"
              id="slug"
              formControlName="slug"
              class="form-input"
              placeholder="Enter slug"
            />
            <div class="error-message" *ngIf="showError('slug')">
              {{ getError('slug') }}
            </div>
          </div>
        </div>
      </div>

      <!-- Names Section -->
      <div class="form-section">
        <h3 class="section-title">Category Names</h3>
        
        <div class="form-row">
          <!-- Arabic Name -->
          <div class="form-group">
            <label for="arName" class="form-label">Arabic Name *</label>
            <input
              type="text"
              id="arName"
              formControlName="arName"
              class="form-input"
              placeholder="أدخل الاسم بالعربية"
              dir="rtl"
            />
            <div class="error-message" *ngIf="showError('arName')">
              {{ getError('arName') }}
            </div>
          </div>

          <!-- English Name -->
          <div class="form-group">
            <label for="enName" class="form-label">English Name *</label>
            <input
              type="text"
              id="enName"
              formControlName="enName"
              class="form-input"
              placeholder="Enter English name"
            />
            <div class="error-message" *ngIf="showError('enName')">
              {{ getError('enName') }}
            </div>
          </div>
        </div>
      </div>

      

      <!-- Media & Status Section -->
      <div class="form-section">
        <h3 class="section-title">Media & Status</h3>
        
        <div class="form-row">
          <!-- Icon Upload -->
          <div class="form-group">
  <label class="form-label">Category Icon</label>

  <button
    type="button"
    class="btn-open-gallery"
    (click)="openGalleryModal()"
  >
    اختيار صورة من الجالري
  </button>

  <div class="image-preview" *ngIf="imagePreview">
    <img
      [src]="imagePreview | ImageUrlPipe"
      alt="Preview"
      class="preview-image"
      appImageFallback
    />

    <button
      type="button"
      (click)="removeImage()"
      class="remove-image-btn"
    >
      ×
    </button>
  </div>
</div>
        </div>

        <!-- Toggle Switches -->
        <div class="toggle-section">
          <div class="toggle-row">
            <div class="toggle-group">
              <label class="toggle-label">Featured Category</label>
              <div class="toggle-container">
                <label class="switch-container">
                  <input 
                    type="checkbox" 
                    formControlName="featured"
                    class="toggle-switch"
                  />
                  <span class="slider"></span>
                </label>
                <span class="toggle-text">
                  {{ categoryForm.get('featured')?.value ? 'Yes' : 'No' }}
                </span>
              </div>
            </div>

            <div class="toggle-group">
              <label class="toggle-label">Top Category</label>
              <div class="toggle-container">
                <label class="switch-container">
                  <input 
                    type="checkbox" 
                    formControlName="top"
                    class="toggle-switch"
                  />
                  <span class="slider"></span>
                </label>
                <span class="toggle-text">
                  {{ categoryForm.get('top')?.value ? 'Yes' : 'No' }}
                </span>
              </div>
            </div>

            <div class="toggle-group">
              <label class="toggle-label">Status</label>
              <div class="toggle-container">
                <label class="switch-container">
                  <input 
                    type="checkbox" 
                    formControlName="status"
                    class="toggle-switch"
                    [checked]="true"
                  />
                  <span class="slider"></span>
                </label>
                <span class="toggle-text">
                  {{ categoryForm.get('status')?.value ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          type="button"
          (click)="goBack()"
          class="cancel-button"
        >
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="categoryForm.invalid || isSubmitting"
          class="submit-button"
        >
          <span *ngIf="isSubmitting" class="loading-spinner"></span>
          {{ isSubmitting ? 'Adding Category...' : 'Add Category' }}
        </button>
      </div>
      <div class="gallery-modal-backdrop" *ngIf="isGalleryModalOpen">
  <div class="gallery-modal">
    <div class="gallery-modal-header">
      <h3>اختيار صورة التصنيف</h3>

      <button
        type="button"
        class="close-modal-btn"
        (click)="closeGalleryModal()"
      >
        ×
      </button>
    </div>

    <div class="gallery-modal-body">
      <app-gallery-picker
        [selectedImages]="selectedPhotos"
        (selectedImagesChange)="onGalleryImagesChange($event)">
      </app-gallery-picker>
    </div>

    <div class="gallery-modal-footer">
      <button
        type="button"
        class="cancel-button"
        (click)="closeGalleryModal()"
      >
        إغلاق
      </button>
    </div>
  </div>
</div>
    </form>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-indicator">
    <div class="spinner"></div>
    <span>Loading form data...</span>
  </div>
</div>